import styled from "styled-components";
import { UserInfoValueField } from "../../styles";

export const UserInfoMetaValue = styled.div`
  ${UserInfoValueField};
`;
